import { HttpClient } from '@angular/common/http';
import {Injectable} from '@angular/core';

@Injectable()
export class ArtistsService {
  constructor(private http: HttpClient) {}

  getArtists = params =>
    this.http.get<Artists>(`/rest-api/admin-panel/api/v1/admin/artists`, {
      params,
    });

  getArtist = artistId => this.http.get<Artists>(`/rest-api/admin-panel/api/v1/admin/artists/${artistId}`, {});

  artistsSearch = params => this.http.get<any>(`/rest-api/v1/artists/search`, {params});

  syncArtist = artistId => this.http.post(`/rest-api/admin-panel/api/v1/admin/artists/${artistId}/sync`, {});

  createArtist = body =>
    this.http.post<ArtistsResults>(`/rest-api/admin-panel/api/v1/admin/artists/create_simple_profile`, body);

  saveArtist = (params, artistId) =>
    this.http.put<ArtistsResults>(`/rest-api/admin-panel/api/v1/admin/artists/${artistId}`, params);

  cropProfilePhoto = (params, artistId) =>
    this.http.put(`/rest-api/admin-panel/api/v1/admin/artists/${artistId}/crop_profile_photo`, params);

  deleteArtist = attemptId => this.http.delete(`/rest-api/admin-panel/api/v1/admin/artists/${attemptId}`);
}
export interface Artists {
  count: number;
  next: string;
  previous: null;
  results: ArtistsResults[];
}

export interface ArtistsResults {
  id: number;
  name: string;
  profile_photo: string;
  music_style: null;
  music_styles: any[];
}
